import { MediaItem } from "../../Media.types";
import MediaCard from "../MediaCard";

interface Props {
  mediaList: MediaItem[];
  onViewMedia: (item: MediaItem) => void;
}

const MediaGrid: React.FC<Props> = ({ mediaList, onViewMedia }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {mediaList.map((item) => (
        <MediaCard key={item.id} item={item} onView={() => onViewMedia(item)} />
      ))}
    </div>
  );
};

export default MediaGrid;
